import React from 'react';


var AceEditor = React.createClass({
    propTypes: {
        mode: React.PropTypes.string,
        code: React.PropTypes.string
    },
    getInitialState: function () {
        return {
            mode: 'powershell',
            code: ''
        };
    },
    componentDidMount: function () {
        this.editor = ace.edit('sourceCodeEditor');
        this.editor.$blockScrolling = Infinity;
        this.editor.getSession().setMode("ace/mode/" + this.props.mode);
        this.editor.setOptions({readOnly: true});
        this.editor.setOptions({minLines: 25});
        this.editor.setOptions({maxLines: 25});
    },
    componentWillReceiveProps: function (nextProps) {
        this.editor.setValue(nextProps.code, null);
        this.editor.clearSelection();
    },
    render: function () {
        const style = {fontSize: '14px !important', border: '1px solid lightgray'};
        return React.DOM.div({
            id: 'sourceCodeEditor',
            style: style,
        });
    }
});

export default AceEditor;




// WEBPACK FOOTER //
// ./app/areas/library/steps/views/ace_editor.jsx